'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _dec2, _class3, _dec3, _class4, _dec4, _class5, _dec5, _class6;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _bill = require('../bill');

var _console = require('../console');

var _table = require('../table');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

function _format(data, model) {
  var type = model.type;

  var value = data[model.code];
  if (model.range && !model.rangeMap) {
    model.rangeMap = _util2.default.toObject(model.range, _lodashCompat2.default.property('value'), _lodashCompat2.default.property('label'));
  }
  if (model.showCode) {
    return data[model.showCode];
  }
  if (model.tpl) {
    return _util2.default.template(model.tpl, data);
  }
  if (model.itemTpl) {
    return _lodashCompat2.default.map(value, function (item) {
      return _util2.default.template(model.itemTpl, item);
    }).join(', ');
  }
  if (type === 'console') {
    return this.renderRowConsole(data, model);
  }
  if (type === 'checkbox') {
    return _lodashCompat2.default.map(value, _lodashCompat2.default.propertyOf(model.rangeMap)).join(', ');
  }
  if (type === 'radio') {
    return model.rangeMap[value];
  }
  if (type === 'date') {
    return _util2.default.formatDatetime(value, model.format || '%Y-%m-%d');
  }
  if (type === 'rangeDate') {
    return _lodashCompat2.default.map(value, function (x) {
      return _util2.default.formatDatetime(x, model.format || '%Y-%m-%d');
    }).join(' - ');
  }
}
var Records = (_dec = _util2.default.reactExtras, _dec(_class = (_temp = _class2 = function (_M$BaseComponent$Mixi) {
  _inherits(Records, _M$BaseComponent$Mixi);

  function Records(props) {
    _classCallCheck(this, Records);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Records).call(this, props));

    _this.defaultActions = {
      search: function search(records) {
        return records.search();
      },
      reset: function reset(records) {
        return records.reset();
      }
    };
    _this.defaultPageSize = 20;

    Object.assign(_this.state, {
      data: null, // 当前数据
      dataAmount: 0, // 数据总条数，主要用于展示分页
      page: 1, // 当前页码
      pageSize: props.model.pageSize || _this.defaultPageSize, // 每页数据条数
      filter: {}, // 搜索条件
      selection: [], // 已选中数据项的标识
      loading: false });
    return _this;
  }

  _createClass(Records, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var model = this.props.model;

      if (model.initialSearch !== false) {
        this.search();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pageSize = nextProps.model.pageSize;
      // pageSize 有两个来源（model 里和从界面上选），这里认为更晚变化的来源有效

      if (pageSize != this.props.model.pageSize) {
        this.setState({ pageSize: pageSize || this.defaultPageSize });
      }
    }
    /**
     * render 方法在继承时被重写的可能性较高，所以这里的实现尽量保持简短
     */

  }, {
    key: 'render',
    value: function render() {
      var model = this.props.model;

      return _react2.default.createElement(
        'div',
        { className: this.classNames('mt-records') },
        _react2.default.createElement(Records.FilterBill, { model: model.search }),
        _react2.default.createElement(Records.Console, { model: model.console, data: this.getSelection() }),
        _react2.default.createElement(Records.DataGrid, { model: model.grid })
      );
    }
    /**
     * 渲染一行数据的操作面板
     */

  }, {
    key: 'renderRowConsole',
    value: function renderRowConsole(data, model) {
      var buttons = model.buttons || this.props.model.console.buttons;
      return _react2.default.createElement(Records.Console, { model: { buttons: buttons }, data: [data], inRow: true });
    }
    /**
     * 获取数据标识的字段名
     * @returns {string}
     */

  }, {
    key: 'getIdField',
    value: function getIdField() {
      var model = this.props.model;

      return model.idField || model.grid.idField; // 后者用于兼容历史用法
    }
    /**
     * 获取已选中数据项的完整对象列表，不包括在当前数据中不存在的条目
     * @returns {Array<Object>}
     */

  }, {
    key: 'getSelection',
    value: function getSelection() {
      var _state = this.state;
      var data = _state.data;
      var selection = _state.selection;

      var dataById = _util2.default.toObject(data, this.getIdField());
      return selection.map(function (i) {
        return dataById[i];
      }).filter(Boolean);
    }
    /**
     * 设置搜索条件，新的条件会被合并（Object.assign）进现有条件
     */

  }, {
    key: 'setFilter',
    value: function setFilter(nextFilter) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(this.setStateAsync(function (state) {
          return { filter: _extends({}, state.filter, nextFilter) };
        })).then(function ($await_5) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
    /**
     * 设置分页条件，置空参数将被忽略
     * 比如 setPagination(2) 只设置当前页码为 2，setPagination(undefined, 10) 只设置分页大小为 10
     */

  }, {
    key: 'setPagination',
    value: function setPagination(page, pageSize) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(this.setStateAsync(_lodashCompat2.default.pick({ page: page, pageSize: pageSize }, Boolean))).then(function ($await_6) {
          return Promise.resolve(this.fetchData()).then(function ($await_7) {
            return $return();
          }.$asyncbind(this, $error), $error);
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
    /**
     * 根据当前搜索条件和分页条件重新获取并设置数据
     */

  }, {
    key: 'fetchData',
    value: function fetchData() {
      return new Promise(function ($return, $error) {
        var $Try_1_Finally = function ($Try_1_Exit) {
          return function ($Try_1_Value) {
            this.setState({ loading: false });
            return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
          }.$asyncbind(this, $error);
        }.$asyncbind(this);

        var $Try_1_Catch = function ($exception_2) {
          return $Try_1_Finally($error)($exception_2);
        }.$asyncbind(this, $Try_1_Finally($error));

        function $Try_1_Post() {
          return Promise.resolve(this.setStateAsync({
            data: res.pageList || [],
            dataAmount: _lodashCompat2.default.get(res, 'page.totalCount', 0)
          })).then(function ($await_8) {
            return $return();
          }.$asyncbind(this, $error), $error);
        }

        var res;
        var fetchData = this.props.fetchData;
        var _state2 = this.state;
        var filter = _state2.filter;
        var pageNo = _state2.page;
        var pageSize = _state2.pageSize;

        var page = { pageNo: pageNo, pageSize: pageSize };
        var condition = _extends({}, filter, { page: page });
        this.setState({ loading: true });
        try {
          return Promise.resolve(fetchData(condition)).then(function ($await_9) {
            res = $await_9;
            return $Try_1_Finally($Try_1_Post).call(this);
          }.$asyncbind(this, $Try_1_Catch), $Try_1_Catch);
        } catch ($exception_2) {
          $Try_1_Catch($exception_2)
        }
      }.$asyncbind(this));
    }
    /**
     * 根据新的条件重新进行搜索，搜索时当前页码会被置为 1
     * @param filter 新的搜索条件，会与现有条件合并
     */

  }, {
    key: 'search',
    value: function search(filter) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(this.setStateAsync({ page: 1 })).then(function ($await_10) {
          return Promise.resolve(new Promise(function ($return, $error) {
            var $logicalAnd_3;

            function $IfStatement_4() {
              return $return($logicalAnd_3);
            }

            if ($logicalAnd_3 = filter) {
              return Promise.resolve(this.setFilter(filter)).then(function ($await_11) {
                $logicalAnd_3 = $await_11;
                return $IfStatement_4.call(this);
              }.$asyncbind(this, $error), $error);
            }

            return $IfStatement_4.call(this);
          }.$asyncbind(this))).then(function ($await_12) {
            return Promise.resolve(this.fetchData()).then(function ($await_13) {
              return $return();
            }.$asyncbind(this, $error), $error);
          }.$asyncbind(this, $error), $error);
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
    /**
     * 重置搜索条件，然后进行搜索
     * Records 本身没有对“默认搜索条件”的支持，重置后会置空还是会置回默认值依赖于搜索子组件的实现
     */

  }, {
    key: 'reset',
    value: function reset() {
      return new Promise(function ($return, $error) {
        return Promise.resolve(this.search(_lodashCompat2.default.mapValues(this.state.filter, _lodashCompat2.default.constant(undefined)))).then(function ($await_14) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
    /**
     * 操作时触发的事件，一般会在操作面板中的按钮被点击时调用
     * @param data 操作关联的数据
     * @param model 操作按钮的配置
     * @param args
     */

  }, {
    key: 'action',
    value: function action(data, model) {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return new Promise(function ($return, $error) {
        var _this2 = this;

        var action = model.action || this.defaultActions[model.code];
        if (action == null) return $return(null);
        data.ids = function () {
          return data.map(_lodashCompat2.default.property(_this2.getIdField()));
        };
        return Promise.resolve(action.apply(undefined, [this, data, model].concat(args))).then(function ($await_15) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
    /**
     * 默认操作
     */

    /**
     * 分页大小
     */

  }]);

  return Records;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin.ChildGetter({
  // 使子组件可以通过 context.records 访问到所属 Records 的实例
  records: function records() {
    return this;
  }
}))), _class2.defaultProps = {
  model: undefined,
  fetchData: undefined
}, _temp)) || _class);

/**
 * Records 子组件的基类，目前只是读取了 context 中的 records 属性
 */

var RecordsComponent = (_dec2 = _util2.default.reactExtras, _dec2(_class3 = function (_M$BaseComponent$Mixi2) {
  _inherits(RecordsComponent, _M$BaseComponent$Mixi2);

  function RecordsComponent() {
    _classCallCheck(this, RecordsComponent);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(RecordsComponent).apply(this, arguments));
  }

  return RecordsComponent;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin('records')))) || _class3);

Records.Component = RecordsComponent;

var RecordsFilterBill = (_dec3 = _util2.default.reactExtras, _dec3(_class4 = function (_Records$Component) {
  _inherits(RecordsFilterBill, _Records$Component);

  function RecordsFilterBill() {
    _classCallCheck(this, RecordsFilterBill);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(RecordsFilterBill).apply(this, arguments));
  }

  _createClass(RecordsFilterBill, [{
    key: 'render',
    value: function render() {
      // 未配置搜索面板时，仍然渲染了 Bill 组件是为了回避一些访问 refs.bill 出错的情况
      if (this.props.model == null) return _react2.default.createElement(_bill.Bill, { ref: 'bill', notice: false });
      var _props$model = this.props.model;
      var fields = _props$model.fields;
      var initData = _props$model.initData;
      var elementFactory = _props$model.elementFactory;
      var dataFactory = _props$model.dataFactory;
      var actionFactory = _props$model.actionFactory;
      var fieldAction = _props$model.fieldAction;
      var onFieldChange = _props$model.onFieldChange;

      var modelExtras = _objectWithoutProperties(_props$model, ['fields', 'initData', 'elementFactory', 'dataFactory', 'actionFactory', 'fieldAction', 'onFieldChange']);

      return _react2.default.createElement(_bill.Bill, {
        ref: 'bill',
        noDataChanged: true,
        className: this.classNames('mt-records_filter-bill'),
        initModel: _extends({ forms: [{ fields: fields }] }, modelExtras),
        initData: initData,
        elementFactory: elementFactory,
        dataFactory: dataFactory,
        actionFactory: actionFactory,
        notice: false,
        fieldAction: fieldAction,
        onFieldChange: onFieldChange
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this5 = this;

      var records = this.context.records;

      records.decorate('setFilter', function (orig) {
        return function () {
          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return new Promise(function ($return, $error) {
            return Promise.resolve(orig.apply(undefined, args)).then(function ($await_16) {
              return Promise.resolve(_util2.default.promisify(this.refs.bill.setData)(records.state.filter)).then(function ($await_17) {
                return $return();
              }.$asyncbind(this, $error), $error);
            }.$asyncbind(this, $error), $error);
          }.$asyncbind(_this5));
        };
      });
      records.decorate('search', function (orig) {
        return function () {
          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          return new Promise(function ($return, $error) {
            var bill = this.refs.bill;

            if (!bill.validate()) return $return(null);
            return Promise.resolve(records.setFilter(bill.getData())).then(function ($await_18) {
              return Promise.resolve(orig.apply(undefined, args)).then(function ($await_19) {
                return $return();
              }.$asyncbind(this, $error), $error);
            }.$asyncbind(this, $error), $error);
          }.$asyncbind(_this5));
        };
      });
      records.decorate('reset', function (orig) {
        return function () {
          return new Promise(function ($return, $error) {
            var bill = this.refs.bill;

            bill.reset();
            return Promise.resolve(records.setStateAsync({ filter: {} })).then(function ($await_20) {
              return Promise.resolve(records.search()).then(function ($await_21) {
                return $return();
              }.$asyncbind(this, $error), $error);
            }.$asyncbind(this, $error), $error);
          }.$asyncbind(_this5));
        };
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var records = this.context.records;

      records.bill = this.refs.bill;
    }
  }]);

  return RecordsFilterBill;
}(Records.Component)) || _class4);

Records.FilterBill = RecordsFilterBill;

var RecordsConsole = (_dec4 = _util2.default.reactExtras, _dec4(_class5 = function (_Records$Component2) {
  _inherits(RecordsConsole, _Records$Component2);

  function RecordsConsole() {
    _classCallCheck(this, RecordsConsole);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(RecordsConsole).apply(this, arguments));
  }

  _createClass(RecordsConsole, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var model = _props.model;
      var data = _props.data;
      var inRow = _props.inRow;
      var records = this.context.records;

      if (model == null) return null;
      var Console_ = this.props.Console || records.props.Console || records.Console || _console.Console;
      model = _extends({}, model, { buttons: model.buttons.filter(function (b) {
          return b.hideIn != (inRow ? 'row' : 'main');
        }) });
      return _react2.default.createElement(Console_, _extends({}, this.props, model, {
        className: this.classNames('mt-records_' + (inRow ? 'row-console' : 'console')),
        data: data,
        action: records.action
      }));
    }
  }]);

  return RecordsConsole;
}(Records.Component)) || _class5);

Records.Console = RecordsConsole;

var RecordsDataGrid = (_dec5 = _util2.default.reactExtras, _dec5(_class6 = function (_Records$Component3) {
  _inherits(RecordsDataGrid, _Records$Component3);

  function RecordsDataGrid() {
    _classCallCheck(this, RecordsDataGrid);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(RecordsDataGrid).apply(this, arguments));
  }

  _createClass(RecordsDataGrid, [{
    key: 'render',
    value: function render() {
      var model = this.props.model;
      var records = this.context.records;
      var _records$state = records.state;
      var data = _records$state.data;
      var dataAmount = _records$state.dataAmount;
      var page = _records$state.page;
      var pageSize = _records$state.pageSize;
      var selection = _records$state.selection;
      var loading = _records$state.loading;

      return _react2.default.createElement(_table.Table, _extends({}, model, {
        className: this.classNames('mt-records_data-grid'),
        data: data,
        idField: records.getIdField(),
        format: this.format,
        pagination: model.pagination !== false && _extends({}, model.pagination, {
          current: page,
          total: dataAmount,
          pageSize: pageSize,
          onChange: records.setPagination,
          onShowSizeChange: records.setPagination
        }),
        rowSelection: model.rowSelection === false ? undefined : _extends({}, model.rowSelection, {
          selectedRowKeys: selection,
          onChange: function onChange(selection) {
            return records.setState({ selection: selection });
          }
        }),
        loading: loading
      }));
    }
  }, {
    key: 'format',
    value: function format() {
      var model = this.props.model;
      var records = this.context.records;

      return (model.format || _format).apply(records, arguments);
    }
  }]);

  return RecordsDataGrid;
}(Records.Component)) || _class6);

Records.DataGrid = RecordsDataGrid;Records.format = _format;

exports.default = Records;